import React from "react";

import { useUser } from "@components/user-context";
import checkCircleIcon from "@pages/onboarding/assets/check-circle-icon.svg";
import exclamationMarkIcon from "@pages/onboarding/assets/exclamation-mark-icon.svg";

export type ShopifyPixelConnectionType = {
  connected: boolean;
  pixelId?: string;
  collectorDomain?: string;
  collectPageViews?: boolean;
};

type ShopifyPixelProps = {
  connection: ShopifyPixelConnectionType | null;
  connectError: string | null;
};

export default function ShopifyPixel({
  connection,
  connectError,
}: ShopifyPixelProps) {
  // NOTE: The below endpoint doesn't yet exist but this is currently an unused component
  const { isAdmin } = useUser().user;

  const connected = connection?.connected;
  const pixelId = connection?.pixelId;
  const collectorDomain = connection?.collectorDomain;

  const renderIcon = () => {
    if (connected) {
      return (
        <img
          className="mr-2 inline-block"
          src={checkCircleIcon}
          alt="Circle check icon"
        />
      );
    }

    return (
      <img
        className="mr-2 inline-block"
        src={exclamationMarkIcon}
        alt="Exclamation mark icon"
      />
    );
  };

  const renderMessage = () => {
    if (connectError) {
      return (
        <span className="text-red-600 text-sm">
          Error connecting pixel. Contact Northbeam Support
        </span>
      );
    }
    if (connected) {
      return <span className="text-good text-sm">Pixel connected 🚀</span>;
    }

    return <span className="text-jupiter text-sm">Pixel status unknown</span>;
  };

  const renderAdminComponent = () => {
    /* Note: This can go away if this doesn't seem to be a
       common problem. It might be nice at that time to replace
       this with admin functionality to hit an endpoint which runs
       a mutation on the pixel so settings can be updated. */
    if (!isAdmin) {
      return null;
    }
    if (!pixelId || !collectorDomain) {
      return (
        <div className="m-3 border p-1">
          <p className="text-xs m-0">Admin Troubleshooting Help</p>
          <span className="text-xs m-0">
            Have client uninstall the Northbeam app on their shopify admin page,
            and then re-install at apps.shopify.com/north-beam.
          </span>
        </div>
      );
    }
    return (
      <div className="m-3 border p-1">
        <p className="text-xs m-0 font-bold">Admin Note</p>
        <span className="text-xs">
          <span className="font-bold">ID:</span> {pixelId}
        </span>
        <span className="text-xs">
          <span className="font-bold ml-2">Domain:</span> {collectorDomain}
        </span>
      </div>
    );
  };

  return (
    <div className="mb-2">
      {/* {renderIcon()}
      {renderMessage()} */}
      {renderAdminComponent()}
    </div>
  );
}
